import { CdkDragDrop, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractDynamicReportViewComponent } from '../../abstract/abstract-dynamic-report-view.component';
import { InterpolatedBlueprint } from '../../models/blueprint.model';
import { ReportRecord } from '../../models/report.model';
import { TemplateField } from '../../models/template.model';
import { IMAGE_FIELD_ID } from '../../shared/templates/config/common';
import { EditableFieldsService } from '../editable-fields.service';
import { onDrop } from '../summary-view/summary-view.helper';
import { CompareActionsToolbarComponent } from './compare-actions-toolbar/compare-actions-toolbar.component';
import { CompareRecordHeaderComponent } from './compare-record-header/compare-record-header.component';
import { NgClass } from '@angular/common';
import { CompareRecordBodyComponent } from './compare-record-body/compare-record-body.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rep-comparison-view',
  templateUrl: './comparison-view.component.html',
  styleUrl: './comparison-view.component.scss',
  providers: [EditableFieldsService],
  imports: [
    CompareActionsToolbarComponent,
    CompareRecordHeaderComponent,
    CdkDropList,
    CompareRecordBodyComponent,
    CdkDrag,
    NgClass
],
})
export class ComparisonViewComponent extends AbstractDynamicReportViewComponent {
  recordNumber: number;
  allFields: TemplateField[];
  allDataFields: TemplateField[];
  readonly recordList = input<any[]>();
  readonly showGroup = input<boolean>(false);
  readonly removeRecord = output<ReportRecord>();
  readonly reportReordered = output<ReportRecord[]>();

  protected prepareGroupsObjectToDisplay(interpolatedBlueprint: InterpolatedBlueprint) {
    super.prepareGroupsObjectToDisplay(interpolatedBlueprint);
    if (this.bodyGroups.length) {
      this.recordNumber = 1;
      this.allFields = [].concat(...(this.bodyGroups || []).map(group => group.fields));
      this.allDataFields = this.allFields.filter(field => field.id !== IMAGE_FIELD_ID);
    }
  }
  public onReorder(cdkDragDropEvent: CdkDragDrop<Array<{ [key: string]: any }>>) {
    onDrop(cdkDragDropEvent, this.recordList(), this.reportReordered);
  }
}
